import React from 'react'

import type { Option, OptionValue } from '@ui-kit/components/formComponents/Select/types'
import { getOptionIdentifier } from '@ui-kit/components/formComponents/Select/utils'
import { body2 } from '@ui-kit/core/typography'

interface Props {
  options: Option[]
  name: string
  setActiveMenuOption: (activeOption: string) => void
  activeMenuOption: string
  onSelectOptionHandler: (optionValue: OptionValue) => void
}

const OptionsContainerComponent = (props: Props) => {
  return (
    <ul className="absolute -bottom-[1px] left-0 right-0 z-50 max-h-[210px] translate-y-full overflow-auto rounded-b-lg border border-t-0 border-solid border-ui-grey-500 bg-ui-light shadow-lg">
      {props.options.map((option) => (
        <li
          className="px-4 py-2.5 aria-selected:bg-ui-grey-50"
          key={option.label}
          id={getOptionIdentifier(option.value, props.name)}
          onMouseEnter={() =>
            props.setActiveMenuOption(getOptionIdentifier(option.value, props.name))
          }
          onClick={() => props.onSelectOptionHandler(option.value)}
          aria-selected={props.activeMenuOption === getOptionIdentifier(option.value, props.name)}
          role="option"
          tabIndex={0}
        >
          <span className={body2()} id={`drop-down-option-${option.value}`}>
            {option.label}
          </span>
        </li>
      ))}
    </ul>
  )
}

export default OptionsContainerComponent
